import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { UserDatabaseConnector } from "../../dataconnector/usersDatabaseConnector";
import PageLoader from "../Common/PageLoader";
import { isResearchGuestProfile, RESEARCH_GUEST_HOME } from "../../utils/users/researchGuest";

const connector = new UserDatabaseConnector();

// An installed web app can start without Safari's local profile or auth state.
// Never mount the legacy shell until Firebase has restored a real session.
export default function LegacyAuthenticationGate({ children }) {
  const [status, setStatus] = useState("pending");
  useEffect(() => {
    let active = true;
    let unsubscribe;
    let generation = 0;
    const subscribe = async () => {
      try {
        const dispose = await connector._onAuthStateChanged(async user => {
          const current = ++generation;
          if (!user) {
            if (active) setStatus("signed-out");
            return;
          }
          try {
            const profile = await connector._getUserData();
            const cachedUserId = profile?.data?.userId || profile?.data?.uid;
            // Invité recherche (sans parc) : l'interface Classique suppose un
            // parc ; il rejoint ses projets en V2.
            if (isResearchGuestProfile(profile?.data) && profile.data.akongoStaff !== true
              && (!cachedUserId || cachedUserId === user.uid)) {
              if (active && current === generation) setStatus("research-guest");
              return;
            }
            const hasContext = Boolean(profile?.data?.zooId || profile?.data?.userZoo?.value) &&
              (!cachedUserId || cachedUserId === user.uid);
            // Login also resumes authenticated sessions and rebuilds the local
            // profile/Redux context when only Firebase persistence survived.
            if (active && current === generation) setStatus(hasContext ? "ready" : "signed-out");
          } catch (_) {
            if (active && current === generation) setStatus("signed-out");
          }
        });
        if (active) unsubscribe = dispose;
        else dispose?.();
      } catch (_) {
        if (active) setStatus("signed-out");
      }
    };
    subscribe();
    return () => { active = false; generation += 1; unsubscribe?.(); };
  }, []);
  if (status === "pending") return <PageLoader />;
  if (status === "signed-out") return <Redirect to="/login" />;
  if (status === "research-guest") return <Redirect to={RESEARCH_GUEST_HOME} />;
  return children;
}

LegacyAuthenticationGate.propTypes = { children: PropTypes.node.isRequired };
